export const appConfig = {
  companyName: 'enhirely',
  websiteUrl: 'https://enhirely.com',
  privacyPolicyUrl: 'https://app.enhirely.com/privacy',
  termOfUseUrl: 'https://app.enhirely.com/terms',
  contactEmail: 'support@enhirely.com',
  sentryDsn: '',
  baseUrl: 'http://localhost:3001',
  // baseUrl: 'https://api.enhirely.com',
};
